<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.0505 13.5305C12.0205 13.5305 11.9805 13.5305 11.9505 13.5305C9.68047 13.4605 7.98047 11.6905 7.98047 9.51047C7.98047 7.29047 9.79047 5.48047 12.0105 5.48047C14.2305 5.48047 16.0405 7.29047 16.0405 9.51047C16.0305 11.7005 14.3205 13.4605 12.1505 13.5305C12.1305 13.5305 12.1305 13.5305 12.1205 13.5305C12.1005 13.5305 12.0705 13.5305 12.0505 13.5305ZM9.47047 9.50047C9.47047 10.8705 10.5405 11.9805 11.9005 12.0305C11.9305 12.0205 12.0305 12.0205 12.1305 12.0305C13.4705 11.9605 14.5205 10.8605 14.5305 9.50047C14.5305 8.11047 13.4005 6.97047 12.0005 6.97047C10.6005 6.97047 9.47047 8.11047 9.47047 9.50047Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.75081 19.9303C4.57081 19.7703 4.49081 19.5303 4.51081 19.3003C4.64081 18.1103 5.38081 17.0003 6.61081 16.1803C9.59081 14.2003 14.4208 14.2003 17.3908 16.1803C18.6208 17.0103 19.3608 18.1103 19.4908 19.3003C19.5208 19.5403 19.4308 19.7703 19.2508 19.9303C17.2608 21.7503 14.6908 22.7503 12.0008 22.7503C9.31081 22.7503 6.74081 21.7503 4.75081 19.9303ZM12.0008 21.2503C14.1708 21.2503 16.2608 20.4903 17.9208 19.1003C17.7408 18.4903 17.2608 17.9003 16.5508 17.4203C14.0908 15.7803 9.92081 15.7803 7.44081 17.4203C6.73081 17.9003 6.26081 18.4903 6.08081 19.1003C7.74081 20.4903 9.83081 21.2503 12.0008 21.2503Z"
      fill="currentColor"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M24 0V24H0V0H24Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75C6.07 22.75 1.25 17.93 1.25 12ZM2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75C6.9 2.75 2.75 6.9 2.75 12Z"
      fill="currentColor"
    />
  </svg>
</template>
